import { put, takeEvery } from 'redux-saga/effects';
import { USER_LOGIN_SUCCESS, changeLocale } from 'react-admin';

export default function* localizationSaga() {
    yield takeEvery(USER_LOGIN_SUCCESS, function* () {
        const language = localStorage.getItem('language');
        if (language) {
            yield put(changeLocale(language));
        }
    })
}


// WEBPACK FOOTER //
// ./src/sagas/localizationSaga.js